// 🔒 ADMIN HISOBI → TAILSCALE ORQALI API (2026-10-03, docs/knowledge/148).
//
// Server admin tokenini faqat tailnet manzilidan qabul qiladi (403 ADMIN_NET_ONLY). Ilgari Mac'da
// Tailscale subnet route (5.189.180.245/32) yoqilgan edi — u BUTUN qurilmaga tegishli, shuning uchun
// Chrome'dagi oddiy hisob (adham) ham Tailscale'ga bog'lanib qolardi va Tailscale relay'i «o'lik»
// bo'lganda hech kim kira olmadi (2026-10-02). Endi route kerak emas: admin ishlatayotgan BRAUZERNING
// O'ZI API'ni tailnet nomiga (Tailscale HTTPS sertifikati, faqat 100.64.0.0/10 dan) yo'naltiradi.
//
//  · Umumiy API 403 ADMIN_NET_ONLY qaytarsa → tailnet manzili ochiladimi tekshiriladi → shu brauzerda
//    belgi (localStorage) qo'yiladi va so'rov tailnet orqali qayta yuboriladi.
//  · Belgi turgan brauzerda barcha fetch / XHR / WebSocket (socket.io) API chaqiruvlari tailnet'ga.
//  · Tailnet'ga yetib bo'lmasa (Tailscale o'chiq) → belgi olinadi, oddiy yo'lga qaytiladi.
const PUBLIC = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
export const TAILNET_API = 'https://khorezmai-backend.tail696d4e.ts.net';
const KEY = 'kh_api_tailnet';

const isOn = () => { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
const setOn = (v) => { try { if (v) localStorage.setItem(KEY, '1'); else localStorage.removeItem(KEY); } catch (e) { } };

function swap(u) {
  if (!PUBLIC || !isOn() || typeof u !== 'string') return u;
  if (u.startsWith(PUBLIC)) return TAILNET_API + u.slice(PUBLIC.length);
  const wsPub = PUBLIC.replace(/^http/, 'ws');
  if (u.startsWith(wsPub)) return TAILNET_API.replace(/^http/, 'ws') + u.slice(wsPub.length);
  return u;
}

export function installApiRoute() {
  if (!PUBLIC || typeof window === 'undefined' || window.__khApiRoute) return;
  window.__khApiRoute = true;

  const origFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : (input && input.url) || String(input);
    const routed = swap(url);
    const req = routed === url ? input
      : (typeof input === 'string' || input instanceof URL ? routed : new Request(routed, input));
    let res;
    try {
      res = await origFetch(req, init);
    } catch (e) {
      if (routed !== url) { setOn(false); return origFetch(input, init); }   // Tailscale o'chiq — umumiy yo'l
      throw e;
    }
    if (res.status === 403 && routed === url && url.startsWith(PUBLIC)) {
      let body = null;
      try { body = await res.clone().json(); } catch (e) { }
      if (body && body.code === 'ADMIN_NET_ONLY') {
        try {
          await origFetch(TAILNET_API + '/version', { cache: 'no-store' });   // javob kelsa (hatto 401) — tailnet ochiq
          setOn(true);
          return origFetch(TAILNET_API + url.slice(PUBLIC.length), init);
        } catch (e) { /* Tailscale yo'q — asl 403 xabari ko'rsatiladi */ }
      }
    }
    return res;
  };

  const xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    return xo.call(this, method, swap(String(url)), ...rest);
  };

  const WS = window.WebSocket;
  function KhWebSocket(url, protocols) {
    return protocols === undefined ? new WS(swap(String(url))) : new WS(swap(String(url)), protocols);
  }
  KhWebSocket.prototype = WS.prototype;
  ['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach((k) => { KhWebSocket[k] = WS[k]; });
  window.WebSocket = KhWebSocket;
}

installApiRoute();
